import React, { useState } from "react";

interface LoginScreenProps {
  onLogin: (email: string, password: string) => Promise<void>;
}

export function LoginScreen({ onLogin }: LoginScreenProps) {
  const [email, setEmail] = useState("admin@roopcottage.co.uk");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError("");
    setBusy(true);

    try {
      await onLogin(email, password);
    } catch (err: any) {
      setError(err && err.message ? err.message : "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#123B36] p-4">
      <div className="w-full max-w-md rounded-2xl bg-slate-50 p-8 shadow-2xl">
        <div className="mb-6 text-center">
          <img src="/logo512.png" alt="Roop Cottage Logo" className="mx-auto mb-3 h-16 w-16 rounded-lg object-contain" />
          <div className="text-lg font-bold text-[#123B36]">Roop Cottage</div>
          <div className="text-xs text-slate-500">Residential Care Home</div>
          <div className="mt-3 text-2xl font-bold text-[#123B36]">RMACS</div>
          <div className="text-xs text-slate-500">Roop Cottage Master Audit &amp; Compliance System</div>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="mb-1 block text-sm font-medium text-slate-700">Email</label>
            <input type="email" value={email} onChange={event => setEmail(event.target.value)} className="w-full rounded-lg border border-slate-300 bg-blue-50 px-3 py-2 text-sm" required />
          </div>
          <div>
            <label className="mb-1 block text-sm font-medium text-slate-700">Password</label>
            <div className="relative">
              <input type={showPassword ? "text" : "password"} value={password} onChange={event => setPassword(event.target.value)} className="w-full rounded-lg border border-slate-300 bg-blue-50 px-3 py-2 pr-10 text-sm" required />
              <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-500">👁</button>
            </div>
          </div>

          {error ? <div className="rounded-lg bg-red-50 p-2 text-sm text-red-700">{error}</div> : null}

          <button type="submit" disabled={busy} className="w-full rounded-lg bg-[#123B36] px-4 py-3 text-sm font-semibold text-white hover:bg-[#0d2b28] disabled:opacity-60">
            {busy ? "Signing in..." : "Sign In"}
          </button>
        </form>

        <div className="mt-6 text-center text-xs text-slate-400">Secure access • CQC compliant • Audit trail enabled</div>
      </div>
    </div>
  );
}